import { render } from "./listRmaOperation.vue?vue&type=template&id=ae968b7e"
import script from "./listRmaOperation.vue?vue&type=script&lang=js"
export * from "./listRmaOperation.vue?vue&type=script&lang=js"

import exportComponent from "/root/workspace/apm-rma-frontend_iTfK/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__